import React, { memo } from 'react';

import PropTypes from 'prop-types';

import { MessageContentType } from '../../BotMessage.constants';

import { contentComponentMap, contentTypeGuardMap } from './MessageContent.constants';

const MessageContent = ({ contentType, contentProps, onCopy }) => {
  const typeGuard = contentTypeGuardMap[contentType];

  if (!typeGuard || !typeGuard(contentProps)) {
    return null;
  }

  const ContentComponent = contentComponentMap[contentType];

  return <ContentComponent contentProps={contentProps} onCopy={onCopy} />;
};

MessageContent.propTypes = {
  contentType: PropTypes.oneOf(Object.values(MessageContentType)).isRequired,
  contentProps: PropTypes.object.isRequired,
  onCopy: PropTypes.func.isRequired,
};

export default memo(MessageContent);
